// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"GridSidebar_sidebar__hg7b7"};